import { SwipeableDrawer } from "@mui/material";
import { Link } from "react-router-dom";
import "./MobileNavDrawer.scss";
import { NAV_ITEMS, SOCIAL_ITEMS } from "./navbar-config";

interface Props {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}

const MobileNavDrawer = ({ isDrawerOpen, setIsDrawerOpen }: Props) => {
  const close = () => setIsDrawerOpen(false);

  return (
    <SwipeableDrawer
      anchor="left"
      className="mobile-nav-drawer"
      open={isDrawerOpen}
      onOpen={() => setIsDrawerOpen(true)}
      onClose={close}
    >
      <div className="mobile-nav-link-container flex-col">
        {NAV_ITEMS.map(({ label, href }) => (
          <Link key={href} to={href} className="nav-link" onClick={close}>
            {label}
          </Link>
        ))}
        <hr className="social-divider" />
        <div className="mobile-nav-social-links-container flex">
          {SOCIAL_ITEMS.map(({ href, iconClass, label }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="nav-social-link"
              aria-label={label}
            >
              <i className={`${iconClass} fa-lg social-icon`}></i>
            </a>
          ))}
        </div>
      </div>
    </SwipeableDrawer>
  );
};

export default MobileNavDrawer;
